"use client";
import {
  __spreadValues
} from "./chunk-N3ETBM74.js";
import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { msalAuthSettings } from "./msal";
import { stashPostLoginTarget } from "./postLoginTarget";
import { deleteSession, updateSession } from "./utils";
import { secondaryMarkets } from "@dfds-pax/utils";
const useHandleLogin = ({ locale, redirectPage, onRedirect }) => {
  const { inProgress, instance } = useMsal();
  useEffect(() => {
    ;
    (async () => {
      if (instance) {
        if (inProgress !== InteractionStatus.None) return;
        const authenticationResult = await instance.acquireTokenSilent({ scopes: msalAuthSettings.scopes }).catch(async () => {
          await loginRedirect(instance, locale, redirectPage);
          return;
        });
        if (!authenticationResult) {
          await deleteSession();
          await loginRedirect(instance, locale, redirectPage);
          return;
        } else {
          instance.setActiveAccount(authenticationResult.account);
          await updateSession(authenticationResult.accessToken);
          onRedirect(redirectPage);
          return;
        }
      }
    })();
  }, [inProgress, instance, locale, redirectPage, onRedirect]);
};
const loginRedirect = async (instance, locale, redirectPage) => {
  const localeLower = locale.toLowerCase();
  const _locale = secondaryMarkets.includes(localeLower) ? "en" : locale;
  stashPostLoginTarget(redirectPage);
  const params = __spreadValues({}, { extraQueryParameters: { ui_locales: _locale }, scopes: msalAuthSettings.scopes });
  await instance.loginRedirect(params);
};
export {
  useHandleLogin
};
